import { createAction, props } from '@ngrx/store';

export const updateLoads = createAction('[Loads] Update', props<{ payload: { loads: Array<number> } }>());

export type LoadsActionsUnion = ReturnType<typeof updateLoads>;
